module.exports = __webpack_public_path__ + "static/img/jiaobiao-guoqi.de8813b3.png";